import { Component, EventEmitter, Output } from '@angular/core';

@Component({
    selector: 'app-conversation-dnd',
    templateUrl: './conversation-dnd.component.html',
    styleUrls: ['./conversation-dnd.component.scss'],
    standalone: true,
    imports: []
})
export class ConversationDndComponent {
  @Output() filesDropped = new EventEmitter<File[]>();

  onDrop(event: DragEvent) {
    event.preventDefault();
    this.filesDropped.emit(Array.from(event.dataTransfer?.files || []));
  }
}
